import { useCallback, useContext, useRef } from 'react';
import { ErrorData, logError } from '@enuan/chat__utils';
import { configContext } from '../../contexts/config/context';
/**
 *
 * @param namespace string
 * @param meta used as REF
 * @returns logError function
 */
export const useLogError = (namespace: string, meta?: any) => {
	const { baseUrl, privateKey } = useContext(configContext);
	// saved as ref to avoid rerendering from meta objects
	const _meta = useRef(meta);

	const _logError = useCallback(
		(id: string, data: ErrorData, sendLog: boolean = true) =>
			logError(
				`${namespace}:${id}`,
				{ ...data, meta: _meta.current },
				sendLog ? { baseUrl, privateKey } : undefined,
			),
		[namespace, privateKey, baseUrl],
	);

	return _logError;
};
